/**
 * SPA 라우트 변경 시 자동 page_view 전송 훅
 * - Layout 컴포넌트 안에서 호출 (createBrowserRouter는 App 레벨에서 useLocation 불가)
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { gtagEvent } from './gtag';

export function usePageView(): void {
  const location = useLocation();

  useEffect(() => {
    gtagEvent('page_view', {
      page_path: location.pathname + location.search,
      page_title: document.title,
      event_source: 'webview',
    });
  }, [location.pathname, location.search]);
}
